module.exports = __webpack_public_path__ + "img/海螵蛸.131481c7.jpg";